import { Button as MuiButton, ButtonGroup as MuiButtonGroup, ButtonGroupProps, ButtonProps, useTheme } from '@mui/material'

import useStyles from './button-group.styles'

interface ButtonGroupButtonM3Props extends ButtonProps {
  selected?: boolean
  icon?: React.ReactNode
  colorVariant?: 'secondary' | 'tertiary'
}

const Button = ({ children, selected = false, icon, colorVariant = 'tertiary', ...props }: ButtonGroupButtonM3Props) => {
  const theme = useTheme()
  const classes = useStyles
  return (
    <MuiButton
      sx={{
        ...classes.button,
        borderRadius: selected ? `${theme.spacing(3)} !important` : `${theme.spacing(1)} !important`,
        backgroundColor: selected
          ? colorVariant === 'tertiary'
            ? theme.palette.tertiary.main
            : theme.palette.ui.inversePrimary
          : theme.palette.secondary.light,
        color: selected ? (colorVariant === 'tertiary' ? '#FFFFFF' : theme.palette.secondary.dark) : theme.palette.secondary.dark,
        gap: icon ? theme.spacing(1) : undefined,
        ...props.sx,
      }}
      {...props}
    >
      {icon}
      {children}
    </MuiButton>
  )
}

const ButtonGroup = ({ children, ...props }: ButtonGroupProps) => {
  const classes = useStyles
  return (
    <MuiButtonGroup variant="contained" disableElevation={true} sx={{ ...classes.buttonGroup, ...props.sx }} {...props}>
      {children}
    </MuiButtonGroup>
  )
}

ButtonGroup.Button = Button

export default ButtonGroup
